import React, { useRef } from 'react';
import Button from 'devextreme-react/button';
import SignatureCanvas from 'react-signature-canvas';
import { clear } from '../../../../../images/icons';
import { newToast } from '../../../..';
import { useScreenSize } from '../../../../../utils/media-query';

type Props = {
  onCancel: () => void;
  onSigned: (values: any) => Promise<void> | void;
  onBack?: () => void;
  isLoading?: boolean;
};

const StepSign: React.FC<Props> = ({ onCancel, onSigned, onBack, isLoading }) => {
  const sigCanvas = useRef<SignatureCanvas | null>(null);
  const { isXSmall } = useScreenSize();
  const handleClear = () => {
    sigCanvas?.current?.clear();
  };

  //Funcion que valida si el canvas esta vacio
  const isCanvasEmpty = () => {
    if (sigCanvas?.current?.isEmpty()) {
      newToast('WARNING', 'Debe firmar el consentimiento para poder continuar.', 5);
      return;
    }
    const dataURL = sigCanvas?.current?.toDataURL();
    if (dataURL) {
      onSigned(dataURL);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div>
        <h4 style={{ marginTop: 0, marginBottom: 0 }}>Firma del paciente/Representante legal</h4>
        <div style={{ marginBottom: 12, borderStyle: 'solid', borderWidth: 2, borderColor: '#ccc', borderRadius: 5 }}>
          <SignatureCanvas ref={sigCanvas} penColor='black' canvasProps={{ width: isXSmall ? 350 : 650, height: 200, className: 'sigCanvas' }} />
        </div>
      </div>
      <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        {onBack && <Button text='Volver' icon='back' onClick={onBack} />}
        <Button text='Cancelar' type='danger' icon='clear' onClick={onCancel} />
        <Button text='Limpiar' type='normal' icon={clear} onClick={handleClear} />
        <Button text={isLoading ? 'Firmando...' : 'Firmar'} type='default' icon='check' onClick={isCanvasEmpty} disabled={isLoading} />
      </div>
    </div>
  );
};

export default StepSign;
